import { render } from "./RedirectForm.vue?vue&type=template&id=1f8108d2"
import script from "./RedirectForm.vue?vue&type=script&lang=js"
export * from "./RedirectForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__